<template>
  <v-content>
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md4>
          <v-card class="elevation-12">
            <v-toolbar dark flat color="primary">
              <v-toolbar-title>Авторизация</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
              <v-form
                ref="login_form"
                lazy-validation
                @keyup.native.enter="validate"
              >
                <v-text-field
                  v-model="username"
                  label="Имя пользователя"
                  prepend-icon="person"
                  type="text"
                  required
                >
                </v-text-field>
                <v-text-field
                  v-model="password"
                  prepend-icon="lock"
                  type="password"
                  label="Пароль"
                  required
                >
                </v-text-field>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" @click="validate">
                    Войти
                  </v-btn>
                </v-card-actions>
              </v-form>
            </v-card-text>
            <v-alert :value="true" v-show="message" :type="message_type">
              {{ message }}
            </v-alert>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-footer absolute
      ><v-spacer></v-spacer> Версия: {{ $store.getters.appVersion }}</v-footer
    >
  </v-content>
</template>

<script>
import config from "./../config";
import db from "./../api/db";
import auth from "./../api/auth";

export default {
  name: "LoginPage",
  data() {
    return {
      valid: true,
      username: null,
      password: null,
      message: null,
      message_type: "info"
    };
  },
  methods: {
    async validate() {
      if (this.$refs.login_form.validate() && this.username && this.password) {
        const result = await auth.login(this.username, this.password);
        if (result.success) {
          const { token, display_name, display_image, role } = result;
          await db.saveToken(token);
          let image = display_image.startsWith("http")
            ? display_image
            : config.imagesBaseUrl + display_image;
          await db.saveUser(display_name, image, role);

          this.$router.push({ name: "main" });
        } else this.$root.$emit("notify", result.message, "red");
      } else
        this.$root.$emit("notify", "Введите имя пользователя и пароль", "red");
    }
  },

  mounted() {}
};
</script>

<style scoped></style>
